import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles<{ maxLines: number }>()(
  ({ spacing }, { maxLines }) => ({
    descriptionContainer: {
      display: "flex",
      flexDirection: "column",
      gap: spacing(1)
    },
    description: {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      margin: 0,
      WebkitLineClamp: maxLines
    },
    descriptionExpanded: {
      display: "block",
      overflow: "visible",
      margin: 0
    },
    viewMoreLink: {
      cursor: "pointer",
      color: lightBlue[700],
      textDecoration: "underline",
      "&:hover": {
        color: blueGrey[900]
      }
    }
  })
)
